module.exports = __webpack_public_path__ + "static/seo-backbone-fab251bc0e3012eb4e39dd0cd8a2a34d.png";